import { all, takeEvery } from 'redux-saga/effects';
import { checkAuth, CHECK_AUTH } from './authentication/checkAuth';
import { fetch, FETCH } from './fetch/fetch';

export default function* rootSaga() {
  yield all([takeEvery(CHECK_AUTH, checkAuth), takeEvery(FETCH, fetch)]);
}
